import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import "../assets/css/Faq_2.css";
import "../assets/css/Faq.css";

const FetchFAQ = (props) => {
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <div>
      <div key={props.idx} className="questionContainer">
        <div key={props.idx} className=" questionBox">
          <div className="questionText">{props.question}</div>
        </div>
        <div className={`ans`}>
          {isReadMore ? props.answer.slice(0, 150) : props.answer}
          {props.answer.length > 150 && (
            <span onClick={toggleReadMore}>
              {isReadMore ? (
                <span className="readMore">..Read More</span>
              ) : (
                <span className="showLess">..Show Less</span>
              )}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

const filtercategory = (faqs) => {
  const templist = [];
  faqs.forEach((mp) => {
    if (templist.includes(mp.category) === false) {
      templist.push(mp.category);
    }
  });
  return templist;
};
const filterSubcategory = (data, cat) => {
  const templist = [];
  data.forEach((r) => {
    r.sub_category.replaceAll("_", " ");
    if (templist.includes(r.sub_category) === false && r.category === cat) {
      templist.push(r.sub_category);
    }
  });
  return templist;
};

const FAQ = ({ faqs }) => {
  // extra work from FAQ
  const { category, subCategory } = useParams();
  let navigate = useNavigate();
  const [categories, setCategories] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null); //Can be used to show the selected category in UI element
  const [subCategories, setSubCategories] = useState(null);

  useEffect(() => {
    window.scrollTo(0,0)
  }, [])
  
  //Runs when user selects a sub category
  const _onSubCategoryClick = (subCategory, category) => {
    navigate(`/${category}/${subCategory}`);
  };

  //Runs when faqs get loaded from Fetch in App.js
  if (faqs.length > 0) {
    if (!categories) {
      let _categories = new Set(faqs.map((faq) => faq.category));
      setCategories(Array.from(_categories));
    }
    if (category && !subCategories) {
      // Runs if we get category from URL
      const _subCategories = [];
      faqs.forEach((faq) => {
        if (faq.category === category) {
          _subCategories.push(faq.sub_category);
        }
      });
      setSubCategories(Array.from(new Set(_subCategories)));
    }
  }
  let nullElement = null;
  //Tried to display the normal categories available if the one from URL doesnt exsists, that didnt worked (obviously you can try to fix it). for the time being theres a place holder that displays the message that there is no such category
  if (categories && selectedCategory) {
    if (!categories.includes(selectedCategory)) {
      nullElement = <h1>No Such category found</h1>;
    }
  }
  if (subCategories && subCategories.length > 0) {
    nullElement = null;
  }
  // -----------------
  return (
    <div>
      <div className="FaqSectionParent">
        <div className="SideBar">
          {filtercategory(faqs).map((faq, idx) => {
            if(faq===category){
              let f = faq.replaceAll('_', ' ');
              return(
              <div key={idx} className="FaqGroup">
                <div
                  key={idx}
                  className="FaqCatogory activee shadow p-2"
                 
                >
                  {f}
                </div>
                {filterSubcategory(faqs, faq).map((val, jdx) => {
                  if(val === subCategory){
                  let s = val.replaceAll('_', ' ');
                  return(
                  <div
                    key={jdx}
                    className="FaqSubCatogory activeeText"
                    onClick={() => {
                      _onSubCategoryClick(val, faq);
                    }}
                  >
                    {s}
                  </div>
            )}else{
              let s = val.replaceAll('_', ' ');
                  return(
                  <div
                    key={jdx}
                    className="FaqSubCatogory"
                    onClick={() => {
                      _onSubCategoryClick(val, faq);
                    }}
                  >
                    {s}
                  </div>
            )
            }
            
            })}
              </div>
            )
            }else{
              let f = faq.replaceAll('_', ' ');
              return(
              <div key={idx} className="FaqGroup">
                <div
                  key={idx}
                  className="FaqCatogory activee p-2"
                  style={{ backgroundColor: "#97c84b", borderRadius: "2px 10px" }}
                >
                  {f}
                </div>
                {filterSubcategory(faqs, faq).map((val, jdx) => {
                  if(val === subCategory){
                  let s = val.replaceAll('_', ' ');
                  return(
                  <div
                    key={jdx}
                    className="FaqSubCatogory activeeText"
                    onClick={() => {
                      _onSubCategoryClick(val, faq);
                    }}
                  >
                    {s}
                  </div>
            )}else{
              let s = val.replaceAll('_', ' ');
                  return(
                  <div
                    key={jdx}
                    className="FaqSubCatogory"
                    onClick={() => {
                      _onSubCategoryClick(val, faq);
                    }}
                  >
                    {s}
                  </div>
            )
            }
            
            })}
              </div>
            )
            }
           })}
        </div>
        <div className="ButtonFaqCont">
          <button
            className="btn btn-primary btn-sml"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasScrolling"
            aria-controls="offcanvasScrolling"
          >
            <i className="bi bi-grid-3x3-gap-fill"></i>
          </button>
          <div
            className="offcanvas offcanvas-start"
            data-bs-scroll="true"
            data-bs-backdrop="false"
            tabIndex="-1"
            id="offcanvasScrolling"
            aria-labelledby="offcanvasScrollingLabel"
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasScrollingLabel">
                
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              {filtercategory(faqs).map((faq, idx) => {
                if(faq===category){
                  let f = faq.replaceAll('_', ' ');
                  return( <div key={idx}>
                    <div className="FaqCatogory activeeText">{f}</div>
                    {filterSubcategory(faqs, faq).map((val, jdx) =>{
                      if(val===subCategory){
                        let v = val.replaceAll('_', ' ');
                       return ( <div
                        className="FaqSubCatogory activeeText"
                        data-bs-toggle="offcanvas"
                        onClick={() => {
                          _onSubCategoryClick(val, faq);
                        }}
                        key={jdx}
                      >
                        {v}
                      </div>)
                      }else{
                        let v = val.replaceAll('_', ' ');
                        return( <div
                        style={{color:'white'}}
                          className="FaqSubCatogory"
                          data-bs-toggle="offcanvas"
                          onClick={() => {
                            _onSubCategoryClick(val, faq);
                          }}
                          key={jdx}
                        >
                          {v}
                        </div>)
                      }
                    })}
                  </div>)
                }else{
                  let f = faq.replaceAll('_', ' ');
                  return( <div key={idx}>
                    <div className="FaqCatogory">{f}</div>
                    {filterSubcategory(faqs, faq).map((val, jdx) => {
                      let v = val.replaceAll('_', ' ');
                      return(
                      
                      <div
                        className="FaqSubCatogory"
                        data-bs-toggle="offcanvas"
                        onClick={() => {
                          _onSubCategoryClick(val, faq);
                        }}
                        key={jdx}
                      >
                        {v}
                      </div>
                    )})}
                  </div>)
                }
              })}
            </div>
          </div>
        </div>
        <div className="faq_Section">
          <h2 className="heading m-4">
            <br />
            अपने सभी सवालों के उत्तर नीचे दिए गए FAQ सेक्शन में पाएं
          </h2>
          <div className="bar"></div>
          <div className="fAQButtonGroup1">
            {filterSubcategory(faqs, category).map((val, jdx) => {
             if(val===subCategory){
              const v = val.replaceAll('_', ' ');
              return(
              <div key={jdx} className="fAQButtonBar activee shadow">
                <div
                  className="FaqSubCatogory  newBtn"
                  onClick={() => {
                    _onSubCategoryClick(val, category);
                  }}
                  key={jdx}
                >
                  {v}
                </div>
              </div>
            )
             }else{
              const v = val.replaceAll('_', ' ');
              return(
              <div key={jdx} className="fAQButtonBar">
                <div
                  className="FaqSubCatogory newBtn"
                  onClick={() => {
                    _onSubCategoryClick(val, category);
                  }}
                  key={jdx}
                >
                  {v}
                </div>
              </div>
            )
             }
             })}
          </div>
          <div className="containerAbout">
            <div className="questionsAbout">
              <div className="cards">
                <div className="cardContainer">
                  {faqs.map((faq, index) => {
                    if (
                      faq.category === category &&
                      faq.sub_category === subCategory
                    ) {
                      return (
                        <>
                          <FetchFAQ
                            key={index}
                            idx={index}
                            question={faq.question}
                            answer={faq.answer}
                          />
                        </>
                      );
                    } else {
                      return null;
                    }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
